<template>
  <div>
    <h5 class="vue-title">
      <strong>{{ $t("PARTNERMASTERHEADER") }}{{ $t(this.FormTitle) }}</strong>
    </h5>
    <b-form @submit.prevent="submitData">
      <b-row>
        <b-col cols="8">
          <b-form-group id="addressField" label-for="input-1">
            <span>
              {{ $t("CATEGORYNAME") }}
              <span class="mandotry-color">*</span>
            </span>
            <b-form-input
              id="categoryName"
              v-model.trim="$v.partnercreateObj.name.$model"
              class="inputField"
              type="text"
              autocomplete="off"
              :maxlength="CONSTANTS.default"
            ></b-form-input>
            <show-errors
              :control="$v.partnercreateObj.name"
              :field="$t('MANDATORY')"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8">
          <b-form-group id="addressField" label-for="input-1">
            <span>提携先名</span><span class="mandotry-color">*</span>
            <b-form-input
              class="inputField"
              type="text"
              :disabled="true"
              autocomplete="off"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="addressField" label-for="input-1">
            <span>{{ $t("POSTALCODE") }}</span
            ><span class="mandotry-color">*</span>
            <b-form-input
              class="inputField"
              :disabled="true"
              @keypress="isNumberValidator($event)"
              type="text"
              autocomplete="name"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="addressField" label-for="input-1">
            <span>{{ $t("PREFECTURES") }}</span
            ><span class="mandotry-color">*</span>
            <b-form-input
              class="inputField"
              :disabled="true"
              type="text"
              autocomplete="off"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="addressField" label-for="input-1">
            <span>{{ $t("CITY") }}</span
            ><span class="mandotry-color">*</span>
            <b-form-input
              class="inputField"
              type="text"
              :disabled="true"
              autocomplete="off"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group id="addressField" label-for="input-1">
            <span>{{ $t("STREETADDRESS") }}</span
            ><span class="mandotry-color">*</span>
            <b-form-input
              class="inputField"
              type="text"
              :disabled="true"
              autocomplete="off"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="addressField" label-for="input-1">
            <span>{{ $t("BUILDINGNAME") }}</span>
            <b-form-input
              class="inputField"
              type="text"
              :disabled="true"
              autocomplete="name"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group id="addressField" label-for="input-1">
            <span>{{ $t("CONTACTFIRSTNAME") }}</span
            ><span class="mandotry-color">*</span>
            <b-form-input
              class="inputField"
              type="text"
              :disabled="true"
              autocomplete="name"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="addressField" label-for="input-1">
            <span>{{ $t("CONTACTNAME") }}</span
            ><span class="mandotry-color">*</span>
            <b-form-input
              class="inputField"
              type="text"
              :disabled="true"
              autocomplete="name"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="addressField" label-for="input-1">
            <span>{{ $t("PHONENUMBER") }}</span
            ><span class="mandotry-color">*</span>
            <b-form-input
              class="inputField"
              type="text"
              :disabled="true"
              autocomplete="off"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="addressField" label-for="input-1">
            <span>{{ $t("EMAIL") }}</span
            ><span class="mandotry-color">*</span>
            <b-form-input
              class="inputField"
              type="text"
              :disabled="true"
              @keypress="preventSpecialChar($event)"
              autocomplete="name"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="addressField" label-for="input-1">
            <span>FAX</span>
            <b-form-input
              class="inputField"
              type="text"
              :disabled="true"
              autocomplete="name"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="8">
          <draggable
            class="dragArea list-group"
            :list="list2"
            group="people"
            @change="log"
          >
            <div
              class="list-group-item"
              v-for="(element, index) in list2"
              :key="element.name"
            >
              <span class="formTextSize">
                {{ element.name }}
                <em @click="changeLabel(element, index)" class="fa fa-edit"></em>
                <em
                  @click="deleteFormItem(element, index)"
                  class="fa fa-times pull-right"
                ></em>
                <input
                  v-show="editOffset == index"
                  type="text"
                  :disabled="true"
                  :id="'item-' + index"
                  @keydown.enter="updatePost"
                  @keydown.esc="cancelEditing"
                  class="form-control"
                  v-model="element.text"
                />
              </span>

              <div v-if="element.type != 'date'">
              <b-form-input
                class="inputField"
                :type="element.type"
                autocomplete="name"
                readonly
              ></b-form-input>
              </div>
               <div v-else>
              <b-form-input
                class="inputField"
                placeholder="YYYY-MM-DD"
                type="text"
                autocomplete="name"
                readonly
              ></b-form-input>
              </div>


            </div>
          </draggable>
        </b-col>

        <b-col>
          <draggable
            class="list-group formTextSize setBottom"
            :list="list1"
            :clone="clone"
            :group="{ name: 'people', pull: 'clone', put: false }"
            @change="log"
          >
            <div
              class="list-group-item"
              v-for="listItem in list1"
              :key="listItem.name"
            >
              {{ listItem.name }}
            </div>
          </draggable>
        </b-col>
      </b-row>
      <b-row>
        <b-col></b-col>
        <b-col>
          <br />

          <button
            class="btn btn-primary pull-right formTextSizeBlack"
            type="submit"
          >
            {{ $t("ADDTO") }}
          </button>
          <b-button
            class="btn btn-secondary pull-right formTextSizeBlack mr-2"
            to="/partners"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <b-modal id="confirmationModal" :title="$t('EDITITEMNAME')" hide-footer>
      <b-form>
        <b-row>
          <b-col sm="12">
            <b-form-input
              class="inputField"
              v-model.trim="$v.category.categoryName.$model"
              type="text"
              autocomplete="name"
            ></b-form-input>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col sm="12">
            <b-button
              variant="primary"
              type="button"
              @click="createPartnerSubmit"
              class="buttons-align-right"
              >{{ $t("ADDTO") }}</b-button
            >
            <b-button
              variant="outline-secondary"
              class="buttons-align-right custom-cancel-css"
              size="sm"
              @click="$bvModal.hide('confirmationModal')"
              >{{ $t("CANCEL") }}</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {
  CATEGORY_LIST,
  CREATE_PARTNER_MASTER,
  EDIT_PARTNER_MASTER,
  GET_PARTNER_MASTER
} from "@/store/actions.type";
import { mapGetters } from "vuex";
import ShowErrors from "@/components/ShowErrors";
import { required } from "vuelidate/lib/validators";
import { isNumberValidator, preventSpecialChar } from "@/shared/utils.js";
import { CONSTANTS } from "@/shared/utils";

import * as _ from "lodash";
export default {
  name: "add-partner",
  components: {
    draggable,
    ShowErrors
  },

  data: function() {
    return {
      preventSpecialChar: preventSpecialChar,
      CONSTANTS: null,

      FormTitle: "",
      isNumberValidator: isNumberValidator,
      list1: [
        //list for the optinal for Partner Templete
        { name: this.$t("TEXT"), type: "text", text: "", id: 1 },
        { name: this.$t("NUMBER"), type: "number", text: "", id: 2 },
        { name: this.$t("DATE"), type: "date", text: "", id: 3 },
        { name: "Email", type: "email", text: "", id: 4 },
        { name: this.$t("PHONENUMBER"), type: "number", text: "", id: 5 },
        { name: "URL", type: "text", text: "", id: 6 }
      ],
      list2: [],
      editOffset: -1,
      editPost: {},
      editPostOri: {},
      category: {
        categoryName: ""
      },
      selectedObj: {
        object: {},
        index: 0
      },
      partnercreateObj: {
        name: ""
      },
      params: {},
      isLoading: ""
    };
  },
  computed: {
    ...mapGetters(["caregory"])
  },

  /*validation for the Each fields in From */
  validations: {
    category: {
      categoryName: {}
    },
    partnercreateObj: {
      name: { required }
    }
  },
  methods: {
    /**
     * Sumbitting the Filled Form
     * Input @param {object} object  this.createPartner object which is filled by the user / in Edit also Using the same function
     * Output @param {boolean}   response Boolean status Api call (true =  success, false = failed)
     */
    submitData(evt) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let paylod = {
          name: this.partnercreateObj.name,
          fields: JSON.stringify(this.list2)
        };
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
        /* Triggering edit api if it is Edit */
        if (_.get(this.params, "id", 0)) {
          paylod["id"] = this.params.id;

          this.$store.dispatch(EDIT_PARTNER_MASTER, paylod).then(data => {
            //Edit Api call
            this.isLoading.hide();
            if (data.status) {
              this.$toast.success({
                message: data.message
              });
              this.$router.push({
                name: "partners"
              });
            } else {
              this.$toast.error({
                message: data.message
              });
            }
          });
        } else {
          /*else part we are just calling the create api */
          this.$store.dispatch(CREATE_PARTNER_MASTER, paylod).then(data => {
            this.isLoading.hide();
            if (data.status) {
              this.$toast.success({
                message: data.message
              });
            } else {
              this.$toast.error({
                message: data.message
              });
            }
            this.$router.push({
              name: "partners"
            });
          });
        }
      }
    },
    createPartnerSubmit(evt) {
      this.$v.$touch();
      if (!this.$v.category.$invalid) {
        this.list2[this.selectedObj.index].name = this.category.categoryName;
        this.$bvModal.hide("confirmationModal");
      }
    },
    log: function(evt) {
      console.log(evt)
      // if (evt.added !== undefined) {
      //   evt.added.element.name = evt.added.element.name;
      // }
    },
    /**
     * Changing the Lable of the Droped Addtitional Field
     * Input @param {object} element  the selected Addtional field Details and @param {Number} index  Index of the  selected Addtional field
     * Output POPUP the Edit confirmationModal
     */
    changeLabel: function(element, index) {
      this.selectedObj = {
        object: element,
        index: index
      };
      this.category = { categoryName: element.name };

      this.$bvModal.show("confirmationModal");
    },
    /**
     * Delete  function of the Droped Addtitional Field
     * Input @param {object} element  the selected Addtional field Details and @param {Number} index  Index of the  selected Addtional field
     * Output Delete the Form Item
     */
    deleteFormItem: function(element, pageIndex) {
      let temp = _.filter(this.list2, (item, index) => index != pageIndex);
      this.list2 = temp;
    },
     /**
     * Redirect function
     * Input
     * Output redirect to mentioned routing Name (  name: "partners" )
     */
    redirect() {
      this.$router.push({
        name: "partners"
      });
    },
    startEditing(index) {
      this.editOffset = index;
      this.editPost = this.list2[index];
      this.editPostOri = JSON.parse(JSON.stringify(this.editPost));
      // set focus ke element input
      this.$nextTick(
        function() {
          document.getElementById("item-user-" + this.editOffset).focus();
        }.bind(this)
      );
    },
    updatePost() {
      this.editOffset = -1;
      this.editPostOri = {};
      this.editPost = {};
    },
     /**
     * Aborting the edit
     * Input
     * OutPut cancel the Editing and return unaltered content
     */
    cancelEditing() {
      this.$set(this.list2, this.editOffset, this.editPostOri);
      this.editOffset = -1;
      this.editPostOri = {};
      this.editPost = {};
    },
    /*Clone Function : Which is used in Drag and drop Feature */
     /**
     * Clone Function
     * Input  @param {object} original object of the Dropped Addtional field
     * OutPut clone the Additional field Which is used in Drag and drop Feature
     */
    clone: function(original) {
      var element = {};
      for (var key in original) {
        if (original.hasOwnProperty(key)) {
          element[key] = original[key];
        }
      }
      return element;
    }
  },
  created() {
    this.CONSTANTS = CONSTANTS;

    this.$toast.removeAll();
    this.$store.dispatch(CATEGORY_LIST);
    this.FormTitle = "CREATE";
    this.params = this.$route.params;
    if (_.get(this.params, "id", 0)) {
      /*prefilling the form if it EditPage*/
      this.FormTitle = "EDIT";
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });

      this.$store
        .dispatch(GET_PARTNER_MASTER, {
          id: _.get(this.params, "id", 0)
        })
        .then(data => {
          this.isLoading.hide();

          if (_.get(data, "status", 0)) {
            let partnerObj = _.get(data, "category");
            let fileds = _.get(partnerObj, "fields", "[]");
            this.list2 = JSON.parse(fileds);
            this.partnercreateObj = {
              name: _.get(partnerObj, "name", "")
            };
          }
        });
    }
  }
};
</script>
<style>
.dragArea {
  min-height: 300px;
  background: #ededed;
  padding: 10px;
}
.list-group-item {
  margin-bottom: 6px;
}
.setBottom {
  bottom: 0;
  width: 93%;
}
.custom-cancel-css{
  margin-right:10px;
}
</style>
